import { captureMessage } from "@sentry/browser";
import { css, html, LitElement, type PropertyValues } from "lit";
import { property } from "lit/decorators/property.js";
import type { SidebarComponent } from "../overlays/sidebar.component.js";

export class CartButtonComponent extends LitElement {
	/** Private variables */

	/** Protected variables */

	/** Public variables */
	@property({ type: String, attribute: "data-target" })
	target = "";

	@property({ type: String, attribute: "aria-expanded", reflect: true })
	_ariaExpanded = "false";

	/** constructor */
	protected override firstUpdated(_changedProperties: PropertyValues) {
		super.firstUpdated(_changedProperties);

		if (!this.target) {
			captureMessage("CartButtonComponent: data-target attribute is not set.", "info");
			return;
		}

		this.addEventListener("click", (e) => {
			e.preventDefault();
			document.querySelector<SidebarComponent>(this.target ?? "#cart-flyout")?.show();
		});

		document.body.addEventListener("cart-flyout:shown", () => {
			this._ariaExpanded = "true";
		});

		document.body.addEventListener("cart-flyout:hidden", () => {
			this._ariaExpanded = "false";
		});
	}

	/** Public methods */

	/** Protected methods */
	protected override render() {
		return html`<slot></slot>`;
	}

	/** Private methods */
	static override get styles() {
		return [
			css`
        :host {
          display: flex;
        }
      `,
		];
	}
}

export function defineCartButtonComponent() {
	if (!customElements.get("y-cart-button")) {
		customElements.define("y-cart-button", CartButtonComponent);
	}
}
